import React from "react";
import LayoutWAM from './_NavigationApp'; // O desde '../_UI/_NavigationApp' según dónde estés

import BroadcastModal from "../Private/Notificaciones/BroadcastModal";

// Layout público (sin sidebar/header)
export const LayoutPublic = ({ children }) => <>{children}</>;

// @deprecated Fix layout-doble-montaje (aprobado): sin consumidores desde
// que App.js dejó de envolver <AppRouter> acá -- causaba que LayoutWAM se
// montara dos veces (esta + la de AppRouter.js:633, que es la que provee
// el <Outlet/> real). No se borra en este commit: grepear antes de
// eliminar por si algo más lo empieza a importar.
// Layout privado 100% Chakra, Sidebar + Header + Burbujas + Notificaciones
export const LayoutPrivate = ({ children }) => (
  <LayoutWAM>
    {children}
    <BroadcastModal />

  </LayoutWAM>
);

export default LayoutPrivate;